import { render, staticRenderFns } from "./clientProfileThirdParties.vue?vue&type=template&id=61a2e640&scoped=true"
import script from "./clientProfileThirdParties.vue?vue&type=script&lang=js"
export * from "./clientProfileThirdParties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a2e640",
  null
  
)

export default component.exports